import React from 'react'

function Patent() {
  return (
    <div>
      <h1>تسجيل براءة اختراع</h1>
    </div>
  )
}

export default Patent
